module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAIVBMVEUAAADjKz/19fX29vboYW/39/flPVDkPU/hIjf////29vYqL8maAAAACHRSTlMA/Pq4Ny/GxjHNrS4AAABPSURBVDjLYxicgKWwAwsQd2Bw7MAKRBgysEu0MUhgl2hk6MABRiWoIbFqJlawalSCGhJa2CUWMVitxCY+azFD0CqsQJWB1QibuHIAw6AEAEWN5p/vOZdBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/id@2x.png
// module id = +bG1
// module chunks = 0